import ticketsStore from "@/app/ticketsManager/store/tickets";

export default {
  modules: {
    ticketsStore,
  },
};
